import React from 'react';
import loadable from '@loadable/component';
import ContentComponent from './ContentComponent';

const HeaderBannerCardsContent = ({ title, text, image, link, primaryButton, secondaryButton }) => {
  // const ContentComponent = loadable(() => import('./ContentComponent.js'), { ssr: false });
  return (
    <ContentComponent
      title={title}
      text={text}
      image={image}
      link={link}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
    />
  );
};

export default HeaderBannerCardsContent;
